import transformToDate from "../../transformToDate";
import {getLidarFileNames} from "../../getLidarFileNames";

function convertDate(dateStr) {
  const monthMap = {
    'JAN': '01', 'FEB': '02', 'MAR': '03', 'APR': '04',
    'MAY': '05', 'JUN': '06', 'JUL': '07', 'AUG': '08',
    'SEP': '09', 'OCT': '10', 'NOV': '11', 'DEC': '12'
  };

  const [year, monthAbbr, day] = dateStr.split('-');
  return `${monthMap[monthAbbr]}/${day}/${year}`;
}

export const springfield_obj_arr_2025 = async (accessToken) =>  {
  try {
    const main_path = 'processed-lidar-data/springfield_mo_processed/';
    const raw_lidar_paths = await getLidarFileNames(main_path, accessToken)
    const lidar_paths = raw_lidar_paths.data.map(item => item.replace(main_path, '').replace('/', ''));
  return lidar_paths.map((path) => {
  const match = path.match(/\d{8}/);
    let date = '';
if (match) {
  const dateStr = match[0]; // "11082025"

  const month = dateStr.slice(0, 2);
  const day = dateStr.slice(2, 4);
  const year = dateStr.slice(4, 8);

  const readableDate = `${month}/${Number(day)}/${year}`;
  date = readableDate;

}  return {
    url: `${process.env.REACT_APP_LIDAR_CDN_URL}/springfield_mo_processed/${path}`,
    name: `Springfield MO - ${path}`,
    description: `Scan of processed Springfield MO, October 2025 data`,
  date_uploaded: new Date(date),
  data_identifier: 'springfield_mo',
  collector: 'NV5',
  projection: "+proj=tmerc +lat_0=35.8333333333333 +lon_0=-92.5 +k=0.999933333 +x_0=500000 +y_0=0 +ellps=GRS80 +towgs84=-0.991,1.9072,0.5129,-1.25033e-07,-4.6785e-08,-5.6529e-08,0 +units=ft +no_defs +type=crs"
  }})
  } catch (error) {
    console.error('Error fetching Springfield MO lidar paths:', error);
    return [];
  }
 
};
